import { StateUpdatedEvent } from 'ag-grid-community';

import { DataGridColsSettingsState } from '../types';

export function checkColumnsSettingsUpdate(event: StateUpdatedEvent): boolean {
  const isInitialEvent = event.sources.includes('gridInitializing');
  if (isInitialEvent) return false;

  const hasReasonToUpdate = event.sources.some((source) => {
    return [
      '',
      'columnOrder',
      'columnPinning',
      'columnSizing',
      'columnVisibility',
    ].includes(source);
  });

  return hasReasonToUpdate;
}

export function extractColumnsSettins(
  event: StateUpdatedEvent,
): DataGridColsSettingsState {
  const { columnOrder, columnPinning, columnSizing, columnVisibility } =
    event.state;

  return { columnOrder, columnPinning, columnSizing, columnVisibility };
}
